// NATIVE 
import React, { useEffect, useState } from "react";


// INSTALLED 
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";



// CUSTOM 


/**
 * MultipleSnackbars component displays multiple snackbars (toast notifications) based on the provided messages list.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.messagesList - List of messages to be displayed as snackbars. Each message should have a `type` and `text` property.
 * @param {string} [props.position="bottom-left"] - The position of the snackbar on the screen.
 * @param {number} [props.autoClose=400] - Duration in milliseconds after which the snackbar will automatically close.
 * @param {boolean} [props.hideProgressBar=false] - Whether to hide the progress bar in the snackbar.
 * @param {boolean} [props.closeOnClick=true] - Whether the snackbar should close when clicked.
 * @param {boolean} [props.pauseOnHover=true] - Whether the snackbar should pause the auto-close timer when hovered.
 * @param {boolean} [props.draggable=true] - Whether the snackbar is draggable.
 * @param {string} [props.theme='colored'] - The theme of the snackbar.
 * @param {string} [props.type="success"] - The default type of the snackbar.
 *
 * @returns {JSX.Element} The rendered MultipleSnackbars component.
 */
const MultipleSnackbars = ({ messagesList = [], position = "bottom-left", autoClose = 400, hideProgressBar = false,
                             closeOnClick = true, pauseOnHover = true, draggable = true, 
                             theme = 'colored', type = "success" }:any) => {

  
  // USE EFFECT 
  useEffect(() => {

    messagesList.forEach((error:any) => {
      notify(error.type, error.text);
    });
    
    
  }, [messagesList]);



  
  // CONST FUNCTIONS 
  const notify = (type:any, message:any):any => {

   

    switch (type) {

      case "success":
        toast.success(message, {
          position,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover, 
          draggable,
          theme,
          style: {
            backgroundColor: "#357a38", // Green
            color: "#ffffff",          // White text
          }
        });
        break;
      case "error":
        toast.error(message, {
          position,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          theme,
          style: {
            backgroundColor: "#d50000", // Red
            color: "#ffffff",          // White text
          }
        });
        break;
      case "warning":
        toast.warning(message, {
          position,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover, 
          draggable, 
          theme,
          style: {
            backgroundColor: "#ffea00", // Yellow
            color: "#ffffff",          // White text
          }
        });
        break;
      case "info":
        toast.info(message, {
          position,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          theme
        });
        break;
      default:
        toast(message, {
          position,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          theme
        });
        break;
    }
  };

  return (
    <>
      <div>
        <ToastContainer />
      </div>
    </>
  );
};

export default MultipleSnackbars;
